import  { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../Header/Header';
import { Footer } from '../Footer/Footer';
import { ROUTES } from '@core/config/constants';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  const isReelsPage = location.pathname === ROUTES.REELS;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  return (
    <div className={`layout ${isReelsPage ? 'layout--reels' : ''}`}>
      <Header />
      <main className={`layout__main ${isReelsPage ? 'layout__main--reels' : ''}`}>
        <div className="layout__content">{children}</div>
      </main>
      {!isReelsPage && <Footer />}
    </div>
  );
};
